import React, { useState, useEffect ,useLayoutEffect} from 'react';
import useMedia from 'use-media';

import image_base from '../../resources/image/GrandeeHamanako2.jpg';
import { Link ,useHistory} from "react-router-dom";
import image_complete from '../../resources/icons/complete.svg';
import image_button from '../../resources/icons/ico_reserve.svg';
import { GolfFooterContainer } from "../organisms/golfFooterContainer";
import { connect , useStore} from 'react-redux';
import common from '../../resources/js/common/common';
import { apiKeyCheck } from '../../const';
import { useRtoaster } from '../../hooks/useRtoaster';

const GolfCompleteContainer = (props) => {
    const {
        setPlayDate1,
        setPlayDate2,
        setDetailCondition,
        setFavoriteCondition,
        setStartTime,
        setGroup,
        setSearchResult,
        setFacility,
        setPlan,
        addTeeTimeList,
        addReserver,
        addInputPlayer,
        setReserveType,
        setKaiinken,
        setCourseName  } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const store = useStore();
    const history = useHistory();

    // rtoasterタグ生成
    let customParam = {};
    if (props.dispName === 'cancel') {
        // 予約キャンセル
        const reserveCheckInfo = store.getState().reserveCheckInfo;
        const riyoDate = new Date(reserveCheckInfo.playDate);
        const course = store.getState().course;
        const facilityCd = course?.length ? course.find(value => value.id == reserveCheckInfo.golfCourseID)?.facilityCd : "";
        customParam = {
            "sisetucd": facilityCd,
            "riyodat": `${riyoDate.getFullYear()}-${(riyoDate.getMonth() + 1).toString().padStart(2, "0")}-${(riyoDate.getDate()).toString().padStart(2, "0")}`,
            "yoyakuno": reserveCheckInfo.reservationNo,
        }
    } else {
        const changeReserveNo = store.getState().changeReserveNo;
        const course = store.getState().course;
        const teeTimeList = store.getState().teeTimeList;
        const plan = store.getState().plan;
        let contractNo = "";
        if (changeReserveNo) {
            // 予約変更
            const reserveCheckInfo = store.getState().reserveCheckInfo;
            let jsonTxt = reserveCheckInfo.reservationsDayInformationList[0].ntgGeneralPurposeItem;
            let jsonObj = JSON.parse(jsonTxt);
            contractNo = jsonObj.ResortTrustInfomation.ownerMemberCode;
            const riyoDate = new Date(reserveCheckInfo?.playDate);
            customParam = {
                "sisetucd": course.find(value => value.id == plan.golfCourseID)?.facilityCd,
                "riyodat": `${riyoDate.getFullYear()}-${(riyoDate.getMonth() + 1).toString().padStart(2, "0")}-${(riyoDate.getDate()).toString().padStart(2, "0")}`,
                "keiyakuno": contractNo,
                "packcd": plan.planid,
                "packnam": plan.planname,
                "coursecd": teeTimeList?.map(value => { return value.courseID })?.join(","),
                "startjikan": teeTimeList?.map(value => { return value.teeTime })?.join(","),
            }
        } else {
            // 新規予約
            const playDate1 = store.getState().playDate1;
            const riyoDate = new Date(playDate1);
            const kaiinken = store.getState().kaiinken;
            kaiinken.forEach((data) => {
                if (data.selected === true) {
                    contractNo = data.contractNo;
                }
            });
            customParam = {
                "sisetucd": course.find(value => value.id == plan.golfCourseID)?.facilityCd,
                "riyodat": `${riyoDate.getFullYear()}-${(riyoDate.getMonth() + 1).toString().padStart(2, "0")}-${(riyoDate.getDate()).toString().padStart(2, "0")}`,
                "keiyakuno": contractNo,
                "packcd": plan.planid,
                "packnam": plan.planname,
                "coursecd": teeTimeList?.map(value => { return value.courseID })?.join(","),
                "startjikan": teeTimeList?.map(value => { return value.teeTime })?.join(","),
            }
        }

    }
    useRtoaster(history.location.pathname, customParam);

    
    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if(Object.keys(state).length !== 0){   
            apiKey = state.apiKey;
        }
        if(apiKey === null){
            store.dispatch({ type: "CLEAR_STATE"});
            history.push("/reserve/login");
        }
        if(apiKey){
        common.doPost(apiKeyCheck, {apikey:apiKey}, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if(!res.data){
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE"});
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
    })

    useEffect(() => {
        // common.versionCheck();
        setPlayDate1(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 3));
        setPlayDate2(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 3));
        setDetailCondition([]);
        setFavoriteCondition([]);
        setStartTime([]);
        setGroup([]);
        setSearchResult({});
        setFacility([]);
        setPlan([]);
        addTeeTimeList([]);
        addReserver({});
        addInputPlayer([]);
        setReserveType([]);
        setCourseName([]);
        setKaiinken([]);
    }, []);

    return (
        <div style={isWideTablet ? props.dispName === 'cancel' ? styles.topMobileCancel : styles.topMobile
            : props.dispName === 'cancel' ? styles.topCancel : styles.top}>
            <div style={isWideTablet ? styles.base2 : styles.base}>
                <div style={styles.complete}></div>
                <p style={styles.completeTitle}>{props.completeTitle}</p>
                <p style={isWideTablet ? styles.completeText2 : styles.completeText}>ご利用いただき誠にありがとうございます。<br />{props.completeBody}<br style={isWideTablet ? styles.deletebr2 : styles.deletebr} />{props.completeBody2}</p>
                {/* <div style={isWideTablet ? styles.btn2 : styles.btn}>
                    <div style={styles.btnImage}></div>
                    <Button buttonText="ホテル予約へ" style={styles.useBtn} />
                </div> */}
                {/* 9月末リリース時点でホテル予約へは非表示のためコメントアウト */}
                <Link style={styles.link} to={"/reserve/golf/search"} >予約一覧に戻る</Link>
            </div>
            <div style={isWideTablet ? styles.footer2 : styles.footer}>
                <GolfFooterContainer />
            </div>
        </div >
    )
}

const styles = {
    topMobile: {
        width: "100%",
        paddingTop: "25px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "calc(100vh - (12.3rem + 75px))",
    },
    top: {
        width: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "calc(100vh - (13.8rem + 100px))",
    },
    topCancel: {
        width: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "calc(100vh - (8.8rem + 100px))",
    },
    topMobileCancel: {
        width: "100%",
        paddingTop: "25px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "calc(100vh - (7.3rem + 75px))",
    },
    complete: {
        width: "50px",
        height: "50px",
        backgroundImage: `url(${image_complete})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "auto",
        margin: "0px auto 10px",
    },
    completeTitle: {
        textAlign: "center",
        fontSize: "1.1em",
    },
    completeText: {
        textAlign: "center",
        fontSize: "small",
    },
    completeText2: {
        textAlign: "center",
        fontSize: "0.7em",
    },
    base: {
        background: "rgba(255,255,255,0.9)",
        marginRight: "auto",
        marginLeft: "auto",
        width: "450px",
        padding: "40px",
    },
    base2: {
        background: "rgba(255,255,255,0.9)",
        marginRight: "auto",
        marginLeft: "auto",
        width: "calc(90% - 30px)",
        padding: "30px 15px",
    },
    box: {
        display: "inline-block",
        textAlign: "center",
        margin: "0px auto",
        width: "100%",
    },
    title: {
        fontSize: "20px",
        fontWeight: "bold",
        marginBottom: "25px",
    },
    link: {
        display: "block",
        padding: "3px",
        color: "#6f6f6f",
        textAlign: "center",
        fontSize: "small",
    },
    deletebr: {
        display: "none",
    },
    deletebr2: {
        display: "block",
    },
    btn: {
        display: "flex",
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        width: "60%",
        height: "40px",
        margin: "30px auto",
        border: "none",
        justifyContent: "center",
    },
    btn2: {
        display: "flex",
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        width: "100%",
        height: "40px",
        margin: "30px auto",
        border: "none",
        justifyContent: "center",
    },
    btnImage: {
        width: "30px",
        height: "30px",
        backgroundImage: `url(${image_button})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        marginTop: "5px",
    },
    useBtn: {
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        display: "inline-block",
        border: "none"
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        marginLeft: "10%",
    },
    breadCrumbArrow: {
        marginRight: "16px",
        marginTop: "0px",
    },
    label: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: "0.9rem",
        letterSpacing: "0.2rem"
    },
    label2: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: 12.6,
        letterSpacing: "0.2rem"
    },
    image: {
        width: 200,
        width: "40%",
        margin: "0 auto",
    },
    form: {
        width: "60%",
        margin: "0px auto 50px",
    },
    line: {
        width: "100%",
        border: "1px solid rgb(204, 204, 204)",
        borderWidth: "1px 0px 0px 0px",
        margin: "45px auto 0px",
    },
    footer: {
        color: "#ffffff",
        position: "absolute",
        bottom: "10px",
        textAlign: "center",
        width: "100%",
    },
    footer2: {
        color: "#ffffff",
        fontSize: "0.6em",
        width: "100%",
        textAlign: "center",
        position: "absolute",
        bottom: "10px",
    },
}

const mapDispatchToProps = (dispatch) => {
    return {
        setPlayDate1: (item) => {
            dispatch({ type: "SELECT_PLAY_DATE1", payload: { playDate1: item } })
        },
        setPlayDate2: (item) => {
            dispatch({ type: "SELECT_PLAY_DATE2", payload: { playDate2: item } })
        },
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
        setFavoriteCondition: (item) => {
            dispatch({ type: "FAVORITE_CONDITION", payload: { favoriteCondition: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setFacility: (item) => {
            dispatch({ type: "SET_FACILITY", payload: { facility: item } })
        },
        setPlan: (item) => {
            dispatch({ type: "SET_PLAN", payload: { plan: item } })
        },
        addTeeTimeList: (item) => {
            dispatch({ type: "ADD_TEETIME_LIST", payload: { teeTimeList: item } })
        },
        addReserver: (item) => {
            dispatch({ type: "ADD_RESERVER", payload: { reserver: item } })
        },
        addInputPlayer: (item) => {
            dispatch({ type: "ADD_INPUT_PLAYER_INFO", payload: { inputPlayerInfo: item } })
        },
        setReserveType: (item) => {
            dispatch({ type: "RESERVE_TYPE", payload: { reserveType: item } })
        },
        setCourseName: (item) => {
            dispatch({ type: "SET_COURSE_NAMES", payload: { courseNames: item } })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: {kaiinken:item} })
        }
    };
}

export default connect(null, mapDispatchToProps)(GolfCompleteContainer);